
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/ProjectAttachments/ProjectAttachments.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./ProjectAttachments.html');
        
        var script = require('./ProjectAttachments.ts').default;
        module.exports = require('./ProjectAttachments.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    